/**
 * Fetch the experiment assignment from the embedded Meristem Context.
 */
export function getStoredExperiments() {
  let experimentStates = window?.meristemContext?.experimentsCookie;
  if (experimentStates) {
    if (typeof experimentStates === "string") {
      experimentStates = JSON.parse(experimentStates);
    }
    return [].concat(experimentStates);
  }
  return null;
}

export function getOptimizelyExperiments() {
  // Provide experiments as GET query parameters for experiment overlap testing
  if (window.URLSearchParams) {
    const params = new URLSearchParams(window.location.search);
    const experiments = params.getAll("experiment").map(item => {
      const [name, variation] = item.split(".");
      return { name, variation };
    });
    if (experiments != null && experiments.length > 0) {
      return experiments;
    }
  }

  if (window?.osxe) {
    return window.osxe.getActiveExperiments();
  }

  if (window.experiments) {
    return window.experiments;
  }

  if (window.experimentName && window.experimentVariation) {
    return [
      {
        name: window.experimentName,
        variation: window.experimentVariation,
      },
    ];
  }

  return [];
}
